import { render, staticRenderFns } from "./UpsertInventoryQuotas.vue?vue&type=template&id=6970cfee"
import script from "./UpsertInventoryQuotas.vue?vue&type=script&lang=js"
export * from "./UpsertInventoryQuotas.vue?vue&type=script&lang=js"
import style0 from "./UpsertInventoryQuotas.vue?vue&type=style&index=0&id=6970cfee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports